
import React from 'react';

const Problem: React.FC = () => {
  const problems = [
    { id: 1, text: "단어는 외우는데, 막상 입을 열면 한 마디도 안 나와요." },
    { id: 2, text: "토플 점수는 필요한데, 학원 강의는 너무 빠르고 독학은 막막해요." },
    { id: 3, text: "비즈니스나 대학 강의를 들을 수 있는 '진짜 실력'인지 확신이 없어요." },
  ];

  return (
    <div className="py-24 bg-[#FAF7F2]">
      <div className="max-w-4xl mx-auto px-4 text-center">
        <h2 className="text-pink-300 font-bold tracking-widest text-sm uppercase mb-4">The Challenge</h2>
        <h3 className="text-3xl md:text-4xl font-extrabold text-slate-800 mb-6 uppercase tracking-tight">Why Is Your English Stuck in Place?</h3>
        <p className="text-slate-400 text-lg mb-12 font-medium">혹시 이런 고민을 하고 계신가요?</p>
        
        <div className="grid grid-cols-1 gap-4 text-left">
          {problems.map((prob) => (
            <div key={prob.id} className="bg-white p-6 rounded-2xl border border-[#F2ECE4] flex items-start space-x-4 hover:border-pink-100 transition-all shadow-sm">
              <span className="text-pink-300 font-black text-xl leading-none">{prob.id}.</span>
              <p className="text-slate-600 font-medium text-lg">"{prob.text}"</p>
            </div>
          ))}
        </div>

        <div className="mt-16 p-8 bg-pink-300 rounded-3xl text-white shadow-lg shadow-pink-200/20">
          <p className="text-xl font-medium">
            혼자서 고민하는 시간은 이제 끝내세요. <br/>
            <span className="text-white font-bold underline decoration-pink-100 underline-offset-8">당신의 약점을 정확히 짚어줄 러닝 메이트</span>가 필요할 때입니다.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Problem;
